/*
 * Om os / Kontakt — hold-kort med hover-video. Ported uændret fra det
 * tidligere assets/page-om-os.js (samme klassenavne/attributter i
 * blocks/_om-team-card.liquid), nu loadet af sections/jm-blocks-page.liquid
 * via "load_shared_assets" (kun på ÉN sektionsinstans).
 *
 * Desktop (hover: hover, pointer: fine): pointerenter spiller, pointerleave
 *   stopper og spoler tilbage (efter fade-out, så tilbagespolingen ikke ses).
 * Touch/ingen hover: IntersectionObserver spiller mens kortet er i syne.
 *   Slås fra ved Save-Data / langsom forbindelse.
 * prefers-reduced-motion: reduce ⇒ ingen video hentes eller afspilles.
 *
 * Videoens src sættes først fra data-oo-src ved første afspilning (ikke
 * class="lazy-video-item" / data-src — det ville kollidere med den globale
 * initLazyloadItem() i assets/utils.js og hente alle tre videoer med det
 * samme). "oo-is-playing" (styrer opacity, se assets/om26.css) sættes først
 * når videoens "playing"-event fyrer — aldrig optimistisk — så en afvist
 * play() (fx iOS Low Power Mode) aldrig efterlader en tom/sort boks.
 */
(function () {
  "use strict";

  if (window.__om26TeamVideoReady) return;
  window.__om26TeamVideoReady = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  var hoverCapable =
    window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function isSaveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /2g/.test(c.effectiveType || "")));
  }

  function play(card, video) {
    if (video.dataset.ooSrc) {
      video.src = video.dataset.ooSrc;
      delete video.dataset.ooSrc;
    }
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === "function") p.catch(function () {});
  }

  function stop(card, video) {
    card.classList.remove("oo-is-playing");
    video.pause();
    window.setTimeout(function () {
      if (!card.classList.contains("oo-is-playing")) {
        try {
          video.currentTime = 0;
        } catch (e) {
          /* ignore */
        }
      }
    }, 450);
  }

  var touchObserver = null;
  if (!hoverCapable && "IntersectionObserver" in window && !isSaveData()) {
    touchObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector(".oo-team-card__video");
          if (!video) return;
          if (entry.isIntersecting) {
            play(entry.target, video);
          } else {
            stop(entry.target, video);
          }
        });
      },
      { threshold: 0.6 }
    );
  }

  function initCard(card) {
    if (card.dataset.ooVidInit) return;
    var video = card.querySelector(".oo-team-card__video");
    if (!video) return;
    card.dataset.ooVidInit = "1";

    video.addEventListener("playing", function () {
      card.classList.add("oo-is-playing");
    });

    if (hoverCapable) {
      card.addEventListener("pointerenter", function () {
        play(card, video);
      });
      card.addEventListener("pointerleave", function () {
        stop(card, video);
      });
    } else if (touchObserver) {
      touchObserver.observe(card);
    }
  }

  function init(root) {
    (root || document)
      .querySelectorAll(".oo-team-card[data-oo-video]")
      .forEach(initCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (evt) {
    init(evt.target);
  });

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) return;
    document.querySelectorAll(".oo-team-card.oo-is-playing").forEach(function (card) {
      var video = card.querySelector(".oo-team-card__video");
      card.classList.remove("oo-is-playing");
      if (video) video.pause();
    });
  });
})();
